import { ApiProperty } from '@nestjs/swagger';
export class PackingSTItems {
    @ApiProperty()
    packingStockTransferItemId: number;
    @ApiProperty()
    itemCategoryId: number;
    @ApiProperty()
    itemSubCategoryId: number;
    @ApiProperty()
    itemId: number;
    @ApiProperty()
    sizeId: number;
    @ApiProperty()
    issuedQty: number;
    @ApiProperty()
    saleOrderId?: number;
    @ApiProperty()
    unitPrice?: number;
    @ApiProperty()
    locationStockInfo?: any[];
    @ApiProperty()
    requiredQty?: number;
    @ApiProperty()
    indentItemId?: number;
    @ApiProperty()
    stockIds?: string;
    @ApiProperty()
    saleOrderItemId?: number;

    /**
     * 
     * @param packingStockTransferItemId 
     * @param itemCategoryId 
     * @param itemSubCategoryId 
     * @param itemId 
     * @param issuedQty 
     */
    constructor(packingStockTransferItemId: number, itemCategoryId: number, itemSubCategoryId: number, itemId: number, sizeId: number, issuedQty: number, saleOrderId?: number, unitPrice?: number, locationStockInfo?:any[], requiredQty?:number,indentItemId?:number,stockIds?: string, saleOrderItemId?: number) {
        this.packingStockTransferItemId = packingStockTransferItemId;
        this.itemCategoryId = itemCategoryId;
        this.itemSubCategoryId = itemSubCategoryId;
        this.itemId = itemId;
        this.sizeId = sizeId;
        this.issuedQty = issuedQty;
        this.saleOrderId = saleOrderId;
        this.unitPrice = unitPrice;
        this.locationStockInfo = locationStockInfo;
        this.requiredQty = requiredQty;
        this.indentItemId = indentItemId;
        this.stockIds = stockIds;
        this.saleOrderItemId = saleOrderItemId;
    }
}